import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";

import mainImage from "../assets/images/New-Products/ageret jpg.jpg";
import thumb1 from "../assets/images/New-Products/extra/Ageret.png";
import thumb2 from "../assets/images/New-Products/ageret jpg.jpg";


import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";

const AgeretProductDetails = () => {
  const images = [thumb1, thumb2];

  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  /* NEW STATES (IMAGE POPUP) */
  const [showImagePopup, setShowImagePopup] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openImagePopup = () => {
    const index = images.indexOf(selectedImage);
    setCurrentIndex(index !== -1 ? index : 0);
    setShowImagePopup(true);
  };

  const nextImage = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  return (
    <>
      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        breadcrumbItems={[
          { label: "Home", to: "/" },
          { label: "Skin Care", to: "/Skin-Care-Products" },
        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">
        <div className="container product-container">
          {/* PRODUCT INFO */}
          <div className="product-info">
            <div className="product-image-section">
              {/* MAIN IMAGE */}
              <div className="image-zoom-wrapper" onClick={openImagePopup}>
                <img
                  src={selectedImage}
                  alt="Ageret Product"
                  className="main-image"
                />
              </div>

              {/* THUMBNAILS */}
              <div className="thumbnail-row">
                {images.map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""
                      }`}
                    onClick={() => {
                      setSelectedImage(img);
                      setCurrentIndex(i);
                    }}
                  />
                ))}
              </div>
            </div>

            {/* PRODUCT DESCRIPTION */}
            <div className="product-description">
              <h2>Ageret</h2>
              <p className="sub-heading">4% Encapsulated Retinol </p>
              <h5>Product Overview</h5>
              <p>
                Ageret is an Age reversal Retinol serum. Retinol is synthetic derivative of Vitamin A.
                The formulation has been manufactured with spherulite technology where in active retinol is coated with Hydrophilic and Lipophilic polymer and therefore the active form Retinoic Acid gets release at dermis and provide the most desired & full potential effects.
                Retinol is a gold-standard ingredient in skin care because it alters the behaviour of aged cells so they act more youthfully. lt smoothens and refines skin’s texture, enhances skin radiance, and treats aging.
              </p>
            </div>
          </div>

          {/* HOW TO USE */}
          {/* <div className="how-to-use-section">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Ageret?</span>
                </h3>
                <p>
                  Apply to clean skin once every 2-3 days. Allow skin to
                  acclimate. Use at night only or as directed by physician.
                </p>
              </div>

              <div
                className="video-thumbnail-wrapper"
                onClick={() => setShowVideo(true)}
              >
                <i className="bi bi-play-fill play-icon"></i>
              </div>
            </div>
          </div> */}

          {/* VIDEO POPUP */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* IMAGE GALLERY POPUP */}
          {showImagePopup && (
            <div className="image-popup">
              <button className="close-btn" onClick={() => setShowImagePopup(false)}>
                &times;
              </button>

              <button className="nav-btn left" onClick={prevImage}>
                &#10094;
              </button>

              <img src={images[currentIndex]} alt="Full View" />

              <button className="nav-btn right" onClick={nextImage}>
                &#10095;
              </button>
            </div>
          )}

          {/* ACCORDION */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""
                    }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab.toUpperCase()}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <p><strong>1. Benefits</strong></p>
                  <ul>
                    <li>Spherulite technology with sustained release and full proof action on dermis.</li>
                    <li>Deep epidermis penetration of vitamins A, C, and E boosts collagen synthesis.</li>
                    <li>Enhances skin tone, texture, resiliency, wrinkle repair, and skin lightening.</li>
                  </ul>
                  <p><strong>2. Additional Additives</strong></p>
                  <ul>
                    <li>Perfection Peptide increases cell turnover.</li>
                    <li>Ceramide repair system strengthens the barrier.</li>
                    <li>Hyaluronic Acid keeps skin soft and plump.</li>
                  </ul>
                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>

                    <ul>
                      <li>Apply to clean skin once every 2-3 days to allow skin time to acclimate (once skin acclimates, Retinol may be used more often if skin can tolerate it. (irritation can occur if this is not followed, use at night time only)</li>
                      <li> Only a few drops are needed as our Retinol Serum is powerful.</li>
                      <li> Wait about 5 minutes to allow full absorption into skin before applying makeup or other products.</li>
                      <li> Allow 30-60 days for full effects or use as directed by physician</li>
                    </ul>
                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li><strong>4% active encapsulated retinol</strong> and <strong>0.1% retinaldehyde</strong>.</li>
                      <li><strong>SK influx:</strong> Skin-identical lipid concentrate containing ceramides 1, 3 & 6, cholesterol, fatty acids, and phytosphingosine which protect the skin’s natural barrier and add hydration.</li>
                      <li><strong>Perfection peptide:</strong> (Hexonyl dipeptide 3 Norleucine acetate) — an active biomimetic tripeptide developed to reactivate the natural desquamation process of the skin. It prevents imperfections, irregularities, and signs of aging.</li>
                      <li><strong>Hyaluronic acid:</strong> Aids in hydration and prevents TEWL (Transepidermal Water Loss).</li>
                      <li><strong>Resveratrol:</strong> A potent antioxidant that protects from environmental and UV-related damage and brightens the skin.</li>
                      <li><strong>Vectorised vitamins:</strong> A, C & E — Vitamin A & C boost collagen synthesis, while Vitamin E detoxifies the skin.</li>
                      <li><strong>Caffeine & arginine:</strong> Aid in proper penetration of active ingredients.</li>
                    </ul>
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AgeretProductDetails;
